<div class="d-flex flex-column flex-grow-1 p-3">
  <div id="registrationComponent">
    <div class="main-login-container mt-5">
      <div class="main-login-form-container">
        <h1>Get started</h1>
        <div
          *ngIf="navmenuvm$ | async as navmenuvm"
          class="link-employee-login btn-with-material-icon"
        >
          <a href="{{ getEmployeeLoginLink(navmenuvm) }}"
            >Looking for employee login? &nbsp;
            <span class="material-icons" style="display: inline-block">arrow_forward</span></a
          >
        </div>
        <div *ngIf="!vm.isSuccess" class="validationError invalid-feedback feedback">
          <ng-container *ngFor="let validationError of vm.validationErrors">
            <p class="at-error" style="color: red !important">
              <span><i class="fas fa-exclamation-circle fa-lg icon" style="top: 0px"></i></span>
              <span class="ml-3">{{ validationError.description }}</span>
            </p>
          </ng-container>
        </div>
        <form #form="spForm" [spForceFeedback]="spForceFeedback">
          <sp-model [model]="vm" modelType="Registration" group="registration">
            <sp-input
              name="firstName"
              [autofocus]="true"
              propertyName="firstName"
              label="First name"
              placeholder="First name"
              [tooltip]="false"
              [disabled]="disabled"
              class="input-container"
            >
            </sp-input>
            <sp-input
              name="lastName"
              propertyName="lastName"
              label="Last name"
              placeholder="Last name"
              [disabled]="disabled"
              class="input-container"
            >
            </sp-input>
            <sp-input
              name="email"
              propertyName="email"
              label="Email"
              placeholder="Email"
              [disabled]="disabled"
              class="input-container"
              #emailInput="ngModel"
              [(ngModel)]="vm.email"
              [spValidationStatus]="emailInput"
            >
            </sp-input>
            <sp-input
              name="phone"
              maskType="phone"
              propertyName="phone"
              label="Phone"
              placeholder="Phone"
              [disabled]="disabled"
              class="input-container"
            >
              <span class="label-tooltip">
                <span
                  >This must be a direct line that can accept voice or text verification (mobile
                  number recommended)</span
                ><br />
              </span>
            </sp-input>

            <sp-control
              *ngIf="!shouldNotDisplay"
              label="Where did you hear about us?"
              [tooltip]="false"
              class="input-container"
            >
              <sp-select
                propertyName="whereDidYouHearAnswer"
                name="whereDidYouHearAnswer"
                id="whereDidYouHearAnswer"
                (change)="onWhereDidYouHearAnswerChanged($event.target)"
                [disabled]="disabled"
              >
                <option *ngFor="let option of whereDidYouHearOptions" [value]="option.value">
                  {{ option.displayName }}
                </option>
              </sp-select>
              <sp-input
                *ngIf="displaywhereDidYouHearDetail"
                name="whereDidYouHearDetail"
                propertyName="whereDidYouHearDetail"
                placeholder="{{ whereDidYouHearDetailPlaceholder }}"
                id="whereDidYouHearDetail"
              >
              </sp-input>
            </sp-control>

            <sp-captcha #captcha *ngIf="captchaEnabled"></sp-captcha>

            <div class="form-group" id="terms-of-use">
              By signing up, you agree to our <a href="{{ termsPage }}">Terms of Use</a>
            </div>

            <div class="form-group">
              <sp-button
                [btn]="btn.Primary"
                (onClick)="createAccount()"
                extraClasses="sign-up-get-started"
              >
                Sign up</sp-button
              >
            </div>
            <div></div>
          </sp-model>
        </form>
        <p>
          Already signed up?
          <b> <a href="{{ loginUrl }}" class="continue-enroll">Continue enrollment</a></b>
        </p>
      </div>
      <div class="illustration-container">
        <img
          src="https://www.surepayroll.com/globalassets/images/resources/man-outside-with-laptop-and-coffee_sp.svg"
        />
      </div>
      <sp-cookie-banner></sp-cookie-banner>
    </div>

    <!-- Employee login button only visible on tablet or mobile -->
    <div class="clickable login-btn-container">
      <a id="employeeLogin" href="https://secure.surepayroll.com/SPF/Login/EE_Auth.aspx">
        <sp-button extraClasses="btn login-button employee-login-body btn-with-material-icon">
          Employee Login &nbsp; <span class="material-icons">arrow_forward</span>
        </sp-button>
      </a>
    </div>
    <!-- End Employee login button visible only on tablet or mobile -->
  </div>
</div>
